'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.goldCurrencySelectorWidget = function (subscriptionPlanModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			showPlans = function (currencies, selectedCurrency) {
				widget.empty();
				currencies.forEach((currency) => {
					mmWidgets('<option></option>').html(currency).val(currency).appendTo(widget);
				});
				widget.val(selectedCurrency);
			};

		subscriptionPlanModel.addEventListener('currencySelected', function (currency) {
			widget.val(currency);
		});

		widget.on('change', function () {
			const currency = widget.val();
			if (currency) {
				subscriptionPlanModel.setSelectedCurrency(currency);
			}
		});

		showPlans(subscriptionPlanModel.getAvailableCurrencies(), subscriptionPlanModel.getSelectedCurrency());
	});
};
